import { render, staticRenderFns } from "./TicketsSteps.vue?vue&type=template&id=6eedf83a&scoped=true"
import script from "./TicketsSteps.vue?vue&type=script&lang=js"
export * from "./TicketsSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eedf83a",
  null
  
)

export default component.exports